import { isPlatformBrowser } from '@angular/common';
import { Inject, Injectable, PLATFORM_ID } from '@angular/core';
import { Big } from 'big.js';

@Injectable({
  providedIn: 'root',
})
export class CommonUtilService {
  private _timer: any = {};
  public isBrowser: boolean = false;
  public isServer: boolean = false;
  public isMobile: boolean = false;
  public isArray: any = Array.isArray;

  constructor(@Inject(PLATFORM_ID) platformid: object) {
    this.isBrowser = isPlatformBrowser(platformid);
    this.isServer = isPlatformBrowser(platformid);
    this.isMobileDevice();
  }

  public isMobileDevice() {
    let smf = this;
    smf.isMobile = false;
    if (this.isBrowser) {
      (function (a: any) {
        if (
          /(android|bb\d+|meego).+mobile|avantgo|bada\/|blackberry|blazer|compal|elaine|fennec|hiptop|iemobile|ip(hone|od)|iris|kindle|lge |maemo|midp|mmp|mobile.+firefox|netfront|opera m(ob|in)i|palm( os)?|phone|p(ixi|re)\/|plucker|pocket|psp|series(4|6)0|symbian|treo|up\.(browser|link)|vodafone|wap|windows ce|xda|xiino|android|ipad|playbook|silk/i.test(
            a
          ) ||
          /1207|6310|6590|3gso|4thp|50[1-6]i|770s|802s|a wa|abac|ac(er|oo|s\-)|ai(ko|rn)|al(av|ca|co)|amoi|an(ex|ny|yw)|aptu|ar(ch|go)|as(te|us)|attw|au(di|\-m|r |s )|avan|be(ck|ll|nq)|bi(lb|rd)|bl(ac|az)|br(e|v)w|bumb|bw\-(n|u)|c55\/|capi|ccwa|cdm\-|cell|chtm|cldc|cmd\-|co(mp|nd)|craw|da(it|ll|ng)|dbte|dc\-s|devi|dica|dmob|do(c|p)o|ds(12|\-d)|el(49|ai)|em(l2|ul)|er(ic|k0)|esl8|ez([4-7]0|os|wa|ze)|fetc|fly(\-|_)|g1 u|g560|gene|gf\-5|g\-mo|go(\.w|od)|gr(ad|un)|haie|hcit|hd\-(m|p|t)|hei\-|hi(pt|ta)|hp( i|ip)|hs\-c|ht(c(\-| |_|a|g|p|s|t)|tp)|hu(aw|tc)|i\-(20|go|ma)|i230|iac( |\-|\/)|ibro|idea|ig01|ikom|im1k|inno|ipaq|iris|ja(t|v)a|jbro|jemu|jigs|kddi|keji|kgt( |\/)|klon|kpt |kwc\-|kyo(c|k)|le(no|xi)|lg( g|\/(k|l|u)|50|54|\-[a-w])|libw|lynx|m1\-w|m3ga|m50\/|ma(te|ui|xo)|mc(01|21|ca)|m\-cr|me(rc|ri)|mi(o8|oa|ts)|mmef|mo(01|02|bi|de|do|t(\-| |o|v)|zz)|mt(50|p1|v )|mwbp|mywa|n10[0-2]|n20[2-3]|n30(0|2)|n50(0|2|5)|n7(0(0|1)|10)|ne((c|m)\-|on|tf|wf|wg|wt)|nok(6|i)|nzph|o2im|op(ti|wv)|oran|owg1|p800|pan(a|d|t)|pdxg|pg(13|\-([1-8]|c))|phil|pire|pl(ay|uc)|pn\-2|po(ck|rt|se)|prox|psio|pt\-g|qa\-a|qc(07|12|21|32|60|\-[2-7]|i\-)|qtek|r380|r600|raks|rim9|ro(ve|zo)|s55\/|sa(ge|ma|mm|ms|ny|va)|sc(01|h\-|oo|p\-)|sdk\/|se(c(\-|0|1)|47|mc|nd|ri)|sgh\-|shar|sie(\-|m)|sk\-0|sl(45|id)|sm(al|ar|b3|it|t5)|so(ft|ny)|sp(01|h\-|v\-|v )|sy(01|mb)|t2(18|50)|t6(00|10|18)|ta(gt|lk)|tcl\-|tdg\-|tel(i|m)|tim\-|t\-mo|to(pl|sh)|ts(70|m\-|m3|m5)|tx\-9|up(\.b|g1|si)|utst|v400|v750|veri|vi(rg|te)|vk(40|5[0-3]|\-v)|vm40|voda|vulc|vx(52|53|60|61|70|80|81|83|85|98)|w3c(\-| )|webc|whit|wi(g |nc|nw)|wmlb|wonu|x700|yas\-|your|zeto|zte\-/i.test(
            a.substr(0, 4)
          )
        ) {
          smf.isMobile = true;
        } else if (window.innerWidth < 1024) {
          smf.isMobile = true;
        }
      })(navigator.userAgent || navigator.vendor);
    }

    return smf.isMobile;
  }

  public getFormattedJson(json: any) {
    return this.isValidString(json) ? JSON.parse(json) : json;
  }

  public getParseJson(str: any) {
    try {
      return JSON.parse(str);
    } catch (e) {
      return str;
    }
  }

  public doDeepCopy(obj: any = {}) {
    return JSON.parse(JSON.stringify(obj));
  }

  public isObject(value: any): boolean {
    return value !== null && 'object' === typeof value;
  }

  public isDefined(value: any): boolean {
    return value && 'undefined' !== typeof value;
  }

  public isValidArray(value: any): boolean {
    return this.isArray(value) && 0 < value.length;
  }

  public isObjectEmpty(objs: any): boolean {
    return Object.keys(objs).length === 0;
  }

  public isValidObject(obj: any): boolean {
    return this.isObject(obj) && Object.keys(obj).length > 0;
  }

  public isValidString(str: any): boolean {
    return 'string' === typeof str && 0 < str.length;
  }

  public isUndefined(value: any) {
    return !value || 'undefined' === typeof value;
  }

  public setDataToLocalStore(key: string, value: any): void {
    if (!this.isValidString(key)) {
      throw new Error('Invalid key!!!!');
    }

    let keyValue = key;
    let getValue = JSON.stringify(value);
    localStorage.setItem(keyValue, getValue);
  }

  public getDataFromLocalStore(localKey: string): any {
    if (!this.isValidString(localKey)) {
      throw new Error('Invali local key!!!');
    }

    let localStoreValue: any = localStorage
      ? localStorage.getItem(localKey)
      : null;
    try {
      return JSON.parse(localStoreValue);
    } catch (e) {
      return localStoreValue;
    }
  }

  public setDataToSessionStore(key: string, value: any): void {
    if (!this.isValidString(key)) {
      throw new Error('Invalid key!!!!');
    }

    let keyValue = key;
    let getValue = JSON.stringify(value);
    sessionStorage.setItem(keyValue, getValue);
  }

  public getDataFromSessionStore(localKey: string): any {
    if (!this.isValidString(localKey)) {
      throw new Error('Invali local key!!!');
    }

    let sessionStoreValue: any = sessionStorage
      ? sessionStorage.getItem(localKey)
      : null;
    try {
      return JSON.parse(sessionStoreValue);
    } catch (e) {
      return sessionStoreValue;
    }
  }

  public getStringLength(str: any) {
    return [...str].length;
  }

  public getYears() {
    const currentYear = new Date().getFullYear();
    const range = (start: any, stop: any, step: any) =>
      Array.from(
        { length: (stop - start) / step + 1 },
        (_, i) => start + i * step
      );
    return range(currentYear, currentYear - 50, -1);
  }

  public getValidData(data: any) {
    return !(this.isUndefined(data) || data === null || data === '');
  }

  public roundNumber(number: number, precision: any): number {
    try {
      let _big = new Big(number);
      let dConvert = _big.toFixed(precision);
      return parseFloat(dConvert);
    } catch (e) {
      return this._roundNumber(number, precision);
    }
  }

  private _roundNumber(number: number, precision: any): number {
    precision = Math.abs(parseInt(precision)) || 0;
    let multiplier = Math.pow(10, precision);
    return Math.round(number * multiplier) / multiplier;
  }

  public delayCallback(id: any, callback: () => void, timeout: number): void {
    const timerId: number = this._timer[id];
    if (timerId) {
      clearTimeout(timerId);
    }
    this._timer[id] = setTimeout(callback, timeout);
  }

  public parseJson(str: string): any {
    try {
      return JSON.parse(str);
    } catch (e) {
      return str;
    }
  }

  public getFloat(data: any) {
    if (this.getValidData(data)) {
      return this.isValidString(data)
        ? parseFloat(data)
        : parseFloat(data.toString());
    } else {
      return 0;
    }
  }

  public checkUploadFileSize(fileSize: number) {
    if (!fileSize) {
      return false;
    }
    const maxLimit = 30 * 1000 * 1024; // 30 MB
    return fileSize <= maxLimit;
  }

  public isValidNumber(num:any):boolean {
    return !isNaN(parseFloat(num)) && isFinite(num);
  }

  public countNumberOfDigit(num:any) {
    return Math.floor(Math.log10(num) + 1);
  }

  public removeDuplicateFromArray(arr:any[]) {
    return arr.filter((value,index)=> arr.indexOf(value) === index);
  }
}
